/* Selects one existing Shopify variant. The enclosing sb-buying-experience
 * retains ownership of cart submission, error handling, analytics and gallery. */
if (!customElements.get('sb-pack-selector')) {
  customElements.define('sb-pack-selector', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = new AbortController();
      const { signal } = this.lifecycle;
      this.form = this.querySelector('.sb-buying__form');
      if (!this.form) return;
      this.querySelectorAll('noscript').forEach((node) => node.remove());
      this.offers = [...this.querySelectorAll('[data-pack-offer]')];
      this.choices = [...this.querySelectorAll('[data-pack-choice]')];
      this.button = this.form.querySelector('[type="submit"]');
      this.error = this.querySelector('.sb-buying__error');
      this.currentMediaKey = null;
      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-pack-offer], [data-pack-choice]')) return;
        this.error.hidden = true;
        this.update();
      }, { signal });
      this.addEventListener('submit', (event) => {
        if (event.target !== this.form) return;
        const offer = this.offers.find((input) => input.checked);
        const choice = this.selectedChoice(offer);
        if (offer && choice?.dataset.available === 'true') return;
        // Stop before the shared cart handler can submit an incomplete choice.
        event.preventDefault();
        event.stopPropagation();
        const message = !offer ? this.dataset.chooseOffer : !choice ? this.dataset.chooseScent : this.dataset.unavailable;
        this.error.textContent = message;
        this.error.hidden = false;
        const target = !offer ? this.offers[0] : this.choices.find((input) => input.dataset.offerId === offer.value && !input.disabled);
        target?.focus();
      }, { signal });
      document.addEventListener('shopify:block:select', (event) => {
        const offer = this.offers.find((input) => input.value === event.detail?.blockId);
        if (!offer || !this.contains(event.target)) return;
        offer.checked = true;
        this.update();
      }, { signal });
      this.update();
    }

    disconnectedCallback() {
      this.lifecycle?.abort();
    }

    selectedChoice(offer) {
      if (!offer) return null;
      const choices = this.choices.filter((input) => input.dataset.offerId === offer.value);
      return offer.dataset.requiresChoice === 'true' ? choices.find((input) => input.checked) : choices[0];
    }

    updateMedia(offer, choice) {
      const parent = this.closest('sb-buying-experience');
      const preview = parent?.querySelector('[data-gallery-intro]');
      const key = offer ? `${offer.value}:${choice?.value || ''}` : 'default';
      if (!preview || key === this.currentMediaKey) return;
      this.currentMediaKey = key;
      const choiceTemplate = choice?.closest('[data-pack-choice-label]').querySelector('[data-pack-media-template]');
      const offerTemplate = offer?.closest('[data-pack-card]').querySelector('[data-pack-offer-media]');
      const template = [choiceTemplate, offerTemplate, this.querySelector('[data-pack-default-media]')]
        .find((candidate) => candidate?.content.querySelector('img'));
      if (!template) return;
      preview.replaceChildren(template.content.cloneNode(true));
      if (offer) parent.selectMedia?.('intro');
    }

    update() {
      const offer = this.offers.find((input) => input.checked);
      const choice = this.selectedChoice(offer);
      this.updateMedia(offer, choice);
      this.querySelectorAll('[data-pack-panel]').forEach((panel) => {
        const selected = panel.dataset.packPanel === offer?.value && offer.dataset.requiresChoice === 'true';
        panel.hidden = !selected;
        panel.disabled = !selected;
      });
      this.offers.forEach((input) => {
        input.closest('[data-pack-card]').classList.toggle('is-selected', input.checked);
      });
      this.choices.forEach((input) => {
        input.closest('[data-pack-choice-label]').classList.toggle('is-selected', input === choice);
      });
      const available = choice?.dataset.available === 'true';
      const variantInput = this.form.elements.id;
      variantInput.value = available ? choice.dataset.variantId : '';
      variantInput.disabled = !available;
      const productInput = this.form.querySelector('[name="product-id"]');
      if (productInput) productInput.value = available ? choice.dataset.productId : '';
      const parent = this.closest('sb-buying-experience');
      parent.dataset.productId = choice?.dataset.productId || '';
      parent.dataset.productUrl = choice?.dataset.productUrl || '';
      // An enabled, incomplete CTA lets keyboard and touch users get a useful
      // validation message. A known unavailable selection cannot be submitted.
      const hasAvailableChoice = this.choices.some((input) => input.dataset.offerId === offer?.value && input.dataset.available === 'true');
      const unavailable = Boolean(offer && !hasAvailableChoice) || Boolean(choice && !available);
      this.button.disabled = unavailable;
      this.button.querySelector('.sb-buying__submit-label').textContent = unavailable ? this.dataset.unavailable : this.dataset.buttonLabel;
      const summary = this.querySelector('[data-pack-summary]');
      summary.hidden = !choice;
      summary.replaceChildren();
      if (choice) {
        const template = choice.closest('[data-pack-choice-label]').querySelector('[data-pack-summary-template]');
        if (template) summary.append(template.content.cloneNode(true));
      }
    }
  });
}
